import React, { Component } from "react";
import { Dialog, IconButton, Button, Icon, Tooltip, Grid, FormControl, Select, InputLabel, Menu, MenuItem, List, ListItem, ListItemText, DialogActions, Chip, TextField } from "@material-ui/core";
import { ValidatorForm, TextValidator, SelectValidator } from "react-material-ui-form-validator";
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import * as actionCreators from '../../store/actions/index';

import InputAdornment from '@material-ui/core/InputAdornment';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import {
    MuiPickersUtilsProvider,
    KeyboardTimePicker,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import moment from 'moment';

export const CreateFieldsDynamicLeadEdit = (data) => {
  var elements = data.state.fieldsList
  var fieldsArray = [];
  elements.map((v, i) => {
    if (v.fieldstatus === true) {
      if (v.fieldtype.id == '1' && ((v.fieldkey == "websites" || v.fieldkey == "social" || v.fieldkey == "phones" || v.fieldkey == "email") && v.is_default)) {
        {
          let tempFieldArray = []
          data.state.fieldsObj[v.fieldkey].values && data.state.fieldsObj[v.fieldkey].values.map((row, index) => {
            if (!row.id) {
              data.handleAddMoreField("id", v.fieldkey, index, v.options[0].id)
            }
            if(v.fieldkey === "email"){//for email validation
              tempFieldArray.push(
                <>
                  <Select
                    name={v.fieldkey}
                    className="input_bx"
                    id={v.id}
                    value={row.id}
                    disableUnderline
                    onChange={(event) => data.handleAddMoreField("id", v.fieldkey, index, event.target.value)}
                    SelectDisplayProps={{ className: "multiple-text-dropdown" }}
                  >
                    {v.options && v.options.map((item, key) =>
                      <MenuItem key={item.id} value={item.id}>{item.optionvalue}</MenuItem>
                    )}
                  </Select>
                  <span style={{color:'#0000008a'}}>{(v.recordeditdefaultvalue == 2) ? "*" :""}</span>
                  <TextValidator
                    ref={ref => data[v.fieldkey] = ref}
                    onBlur={(event) => data.focusOutSubmitForm(event,v.fieldkey)}
                    type="text"
                    id={v.id}
                    placeholder={"Add " + v.fieldkey}
                    className="w-100 input_bx"
                    onChange={(event) => data.handleAddMoreField("value", v.fieldkey, index, event.target.value)}
                    name={v.fieldkey}
                    value={row.value}
                    disabled={v.recordeditdefaultvalue == 3?true:false}
                    validators={(v.recordeditdefaultvalue == 2) ? ["required","isEmail"] : ["isEmail"]}
                    errorMessages={(v.recordeditdefaultvalue == 2) ? ["this field is required","enter valid email address."] : ["enter valid email address."]}
                  />
                </>
              )
            }else{
              
              tempFieldArray.push(
                <>
                  <Select
                    name={v.fieldkey}
                    id={v.id}
                    value={row.id}
                    className="input_bx"
                    disableUnderline
                    onChange={(event) => data.handleAddMoreField("id", v.fieldkey, index, event.target.value)}
                    SelectDisplayProps={{ className: "multiple-text-dropdown" }}
                  >
                    {v.options && v.options.map((item, key) =>
                      <MenuItem key={item.id} value={item.id}>{item.optionvalue}</MenuItem>
                    )}
                  </Select>
                  <TextValidator
                    type="text"
                    id={v.id}
                    placeholder={"Add " + v.fieldkey}
                    className="w-100 input_bx"
                    onChange={(event) => data.handleAddMoreField("value", v.fieldkey, index, event.target.value)}
                    ref={ref => data[v.fieldkey] = ref}
                    onBlur={(event) => data.focusOutSubmitForm(event,v.fieldkey)}
                    name={v.fieldkey}
                    value={row.value}
                    disabled={v.recordeditdefaultvalue == 3 ? true : false}
                    
                    
                  />
                  {v.fieldkey != "email" && row.value && index == (data.state.fieldsObj[v.fieldkey].values.length - 1) &&
                    <span className="add-more-field" type="button" onClick={() => { data.addNewField(v.fieldkey, v.options[0]) }}>Add more</span>
                  }
                </>
              )
            }
          })
          fieldsArray.push(
            <Grid item xs={12}>
              {tempFieldArray}
            </Grid>
          )
        }

      } else if (v.fieldtype.id == '1' && v.id == '1') {
        fieldsArray.push(<><Grid item xs={12}>
          <TextValidator
            type="text"
            id={v.id}
            disabled={v.recordeditdefaultvalue == 3 ? true : false}
            className="w-100 input_bx"
            required={(v.recordcreationdefaultvalue == 2) ? true:false}
            label={"First Name"}
            placeholder={"Add First Name"}
            onChange={(event) => data.handleChange({ fieldid: v.id, leadvalue: event.target.value }, v.fieldkey)}
            ref={ref => data[v.fieldkey] = ref}
            onBlur={(event) => data.focusOutSubmitForm(event,v.fieldkey)}
            name={v.fieldkey}
            value={data.state.fieldsObj[v.fieldkey] ? data.state.fieldsObj[v.fieldkey].leadvalue : ""}
            validators={(v.recordeditdefaultvalue == 2) ? ["required"] : []}
            errorMessages={(v.recordeditdefaultvalue == 2) ? ["this field is required"] : []}
          />
        </Grid>
          <Grid item xs={12}>
            <TextValidator
              type="text"
              id="lastname"
              disabled={v.recordeditdefaultvalue == 3 ? true : false}
              className="w-100 input_bx"
              label={"Last Name"}
              placeholder={"Add Last Name"}
              onChange={(event) => data.handleNormalFields(event)}
              ref={ref => data[v.fieldkey] = ref}
              onBlur={(event) => data.focusOutSubmitForm(event,v.fieldkey)}
              name={"lastname"}
              value={data.state.lastname}
              
              
            />
          </Grid></>
        )
      } else if (v.fieldtype.id == '1' && v.fieldkey == 'tags') {
        var valTag = [];
        if (data.state.fieldsObj[v.fieldkey]) {
          valTag = data.state.fieldsObj[v.fieldkey].values
        }
        fieldsArray.push(<Grid item xs={12}>

          <Autocomplete
            disableOpenOnFocus
            multiple
            value={valTag}
            filterSelectedOptions
            disabled={v.recordeditdefaultvalue == 3 ? true : false}
            name={v.fieldkey}
            id="tagInputId"
            options={data.state.systemTagsList.map(option => option.tagname)}
            freeSolo
            onChange={(event, value) => data.handleChange({ fieldid: v.id, values: value }, v.fieldkey,'allowSubmitChange')}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip label={option.charAt(0).toUpperCase() + option.slice(1)} {...getTagProps({ index })} />
              ))
            }
            renderInput={params => (
              <TextValidator
                {...params}
                label="Tags"
                placeholder="Add Tag"
                className="w-100 input_bx"
                ref={ref => data[v.fieldkey] = ref}
                onBlur={(event) => data.focusOutSubmitForm(event,v.fieldkey)}
                onFocus={() => 
                  setTimeout(() => {
                    document.getElementById("tagInputId").value = "";
                  },0)
                }
              />
            )}
          />
        </Grid>)
      }else if (v.fieldtype.id == '1' && v.id == '4') {//owner field
        var nameOwner = [];
        if (data.state.fieldsObj[v.fieldkey]) {
          nameOwner = data.state.fieldsObj[v.fieldkey].values
        }
        fieldsArray.push(<Grid item xs={12}>
          <FormControl className="w-100 input_bx">
                <Autocomplete
                  disableOpenOnFocus
                  forcePopupIcon={false}
                  name={v.fieldkey}
                  options={data.state.usersListArray}
                  getOptionLabel={option => option.name}
                  value={nameOwner}
                  disabled={v.recordeditdefaultvalue == 3 ? true : false}
                  name={v.fieldkey}
                  onChange={(event, value) => data.handleChange({ fieldid: v.id, values: value }, v.fieldkey,'allowSubmitChange')}
                  id={v.id}
                  renderInput={params => (
                    <TextValidator
                      ref={ref => data[v.fieldkey] = ref}
                      onBlur={(event) => data.focusOutSubmitForm(event,v.fieldkey)}
                      {...params}
                      placeholder="Add Owner"
                      variant="standard"
                      label={"Owner"}
                      fullWidth
                      className="input_bx"
                    />
                  )}
                />
              </FormControl>
        </Grid>)
      } else if (v.fieldtype.id == '1' && v.id == '14') {// value field
        fieldsArray.push(
          <>
            {data.state.focusValue &&
              <Grid item xs={4}>
                <FormControl className="w-100 input_bx">
                  {/* <InputLabel>{v.fieldlabel}</InputLabel> */}
                  <SelectValidator
                    label={v.fieldlabel}
                    value={data.state.companyCurrencyData.currencyid}
                    name={"currency"}
                    id={"currency"}
                    SelectProps={{ onClose: data.currencyDropdownClose }}
                    placeholder={"Add "+v.fieldlabel}
                    
                  >
                    <MenuItem className="select-menu-item item-with-link" value={data.state.companyCurrencyData.currencyid}>{data.state.companyCurrencyData.detail.code}</MenuItem>
                  </SelectValidator>
                </FormControl>
              </Grid>
            }
            <Grid item xs={data.state.focusValue ? 8 : 12} row className={data.state.focusValue ? "checkbox-margin-18" : ""}>
              <TextValidator
                type="number"
                pattern="[0-9]*"
                id={v.id}
                disabled={v.recordeditdefaultvalue == 3 ? true : false}
                className="w-100 input_bx"
                onFocus={data.focusInValue}
                label={!data.state.focusValue ? v.fieldlabel : ""}
                onChange={(event) => data.handleChange({ fieldid: v.id, leadvalue: event.target.value }, v.fieldkey)}
                onKeyPress={ event => ( event.key === '-') && event.preventDefault() }

                ref={ref => data[v.fieldkey] = ref}
                onBlur={(event) => data.focusOutSubmitForm(event,v.fieldkey)} 
                name={v.fieldkey}
                placeholder={"Add Value"}
                value={data.state.fieldsObj[v.fieldkey] ? data.state.fieldsObj[v.fieldkey].leadvalue : ""}
                
                
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      {data.state.companyCurrencyData.symbol}
                    </InputAdornment>
                  )
                }}
              />
            </Grid>
          </>
        )
      } else if (v.fieldtype.id == '1' || v.fieldtype.id == '9') {
        fieldsArray.push(<Grid item xs={12}>
          <TextValidator
            type="text"
            id={v.id}
            disabled={v.recordeditdefaultvalue == 3 ? true : false}
            className="w-100 input_bx"
            label={v.fieldlabel}
            onChange={(event) => data.handleChange({ fieldid: v.id, leadvalue: event.target.value }, v.fieldkey)}
            ref={ref => data[v.fieldkey] = ref}
            onBlur={(event) => data.focusOutSubmitForm(event,v.fieldkey)}
            name={v.fieldkey}
            value={data.state.fieldsObj[v.fieldkey] ? data.state.fieldsObj[v.fieldkey].leadvalue : ""}
            placeholder={"Add " + v.fieldlabel}
            
          />
        </Grid>)
      }
      else if (v.fieldtype.id == '6' || v.fieldtype.id == '10' || v.fieldtype.id == '7') {
        fieldsArray.push(<Grid item xs={12}>
          <TextValidator
            type="number"
            id={v.id}
            disabled={v.recordeditdefaultvalue == 3 ? true : false}
            className="w-100 input_bx"
            label={v.fieldlabel}
            onChange={(event) => data.handleChange({ fieldid: v.id, leadvalue: event.target.value }, v.fieldkey)}
            ref={ref => data[v.fieldkey] = ref}
            onBlur={(event) => data.focusOutSubmitForm(event,v.fieldkey)}
            name={v.fieldkey}
            value={data.state.fieldsObj[v.fieldkey] ? data.state.fieldsObj[v.fieldkey].leadvalue : ""}
            placeholder={"Add " + v.fieldlabel}
            
          />
        </Grid>)
      }

      if (v.fieldtype.id == '2' && v.id == "8") {//Address Fields.
        var displayMapLink = false;
        var mapAddress="";

        if(data.state.fieldsObj[v.fieldkey] && data.state.fieldsObj[v.fieldkey].leadvalue != "" || data.state.city || data.state.state || data.state.country || data.state.zipcode){
          displayMapLink = true
          var line1 = ""
          
          if(data.state.fieldsObj[v.fieldkey] != undefined){
            line1 = data.state.fieldsObj[v.fieldkey].leadvalue 
          }
          var line2 = data.state.city 
          var line3 = data.state.addressState
          var line4 = (data.state.country && data.state.country.name)?data.state.country.name:""; 
          var line5 = data.state.zipcode
          var mapAddress = encodeURI(line1+" "+line2+" "+line3+" "+line5+" "+line4);
        }
        fieldsArray.push(
          <>
            {displayMapLink && 
              <Grid item xs={12}>
                <a className="pull-right" style={{color:'#7467ef'}} target="_blank" href={"https://maps.google.com/?q=" + mapAddress}>Address map</a>
              </Grid>
            }
            <Grid item xs={12}>
              <TextValidator
                multiline
                type="text"
                id={v.id}
                placeholder={"Add " + v.fieldlabel}
                disabled={v.recordeditdefaultvalue == 3 ? true : false}
                className="w-100 input_bx"
                label={v.fieldlabel}
                onChange={(event) => data.handleChange({ fieldid: v.id, leadvalue: event.target.value }, v.fieldkey)}
                ref={ref => data[v.fieldkey] = ref}
                onBlur={(event) => data.focusOutSubmitForm(event,v.fieldkey)}
                name={v.fieldkey}
                value={data.state.fieldsObj[v.fieldkey] ? data.state.fieldsObj[v.fieldkey].leadvalue : ""}
              />
            </Grid>
            <Grid item xs={4}>
              <TextValidator
                type="text"
                id={"city"}
                disabled={v.recordeditdefaultvalue == 3 ? true : false}
                className="w-100 input_bx"
                label={"City"}
                placeholder={"Add City"}
                onChange={(event) => data.handleNormalFields(event)}
                ref={ref => data['city'] = ref}
                onBlur={(event) => data.focusOutSubmitForm(event,'city')}
                name={"city"}
                value={data.state.city}
                
                
              />
            </Grid>
            <Grid item xs={4}>
              <TextValidator
                type="text"
                id={"addressState"}
                disabled={v.recordeditdefaultvalue == 3 ? true : false}
                className="w-100 input_bx"
                placeholder={"Add State"}
                label={"State"}
                onChange={(event) => data.handleNormalFields(event)}
                ref={ref => data['addressState'] = ref}
                onBlur={(event) => data.focusOutSubmitForm(event,'addressState')}
                name={"addressState"}
                value={data.state.addressState}
                
                
              />
            </Grid>
            <Grid item xs={4}>
              <TextValidator
                type="text"
                id={"zipcode"}
                disabled={v.recordeditdefaultvalue == 3 ? true : false}
                className="w-100 input_bx"
                placeholder={"Add Zip code"}
                label={"Zip code"}
                onChange={(event) => data.handleNormalFields(event)}
                ref={ref => data['zipcode'] = ref}
                onBlur={(event) => data.focusOutSubmitForm(event,'zipcode')}
                name={"zipcode"}
                value={data.state.zipcode}
                
                
              />
            </Grid>
            <Grid item xs={12}>
              <FormControl className="w-100 input_bx">
                <Autocomplete
                  disableOpenOnFocus
                  forcePopupIcon={false}
                  disabled={v.recordeditdefaultvalue == 3 ? true : false}
                  name={"country"}
                  onChange={data.handleCountryChange}
                  id={"country"}
                  value={data.state.country}
                  options={data.state.countryListArray}
                  getOptionLabel={option => option.name}
                  renderInput={params => (
                    <TextValidator
                      ref={ref => data['country'] = ref}
                      onBlur={(event) => data.focusOutSubmitForm(event,'country')}
                      {...params}
                      variant="standard"
                      placeholder={"Add Country"}
                      label={"Country"}
                      fullWidth
                      className="input_bx"
                    />
                  )}
                />
              </FormControl>
            </Grid>
          </>
        )
      } else if (v.fieldtype.id == '2') {
        fieldsArray.push(<Grid item xs={12}>
          <TextValidator
            multiline
            type="text"
            id={v.id}
            disabled={v.recordeditdefaultvalue == 3 ? true : false}
            className="w-100 input_bx"
            label={v.fieldlabel}
            placeholder={"Add " + v.fieldlabel}
            onChange={(event) => data.handleChange({ fieldid: v.id, leadvalue: event.target.value }, v.fieldkey)}
            ref={ref => data[v.fieldkey] = ref}
            onBlur={(event) => data.focusOutSubmitForm(event,v.fieldkey)}
            name={v.fieldkey}
            value={data.state.fieldsObj[v.fieldkey] ? data.state.fieldsObj[v.fieldkey].leadvalue : ""}
            
            
          />
        </Grid>)
      }

      if (v.fieldtype.id == '4') {
        if (v.id === "11" || v.id === "3" || v.id === "5") {
          var valDropdown = "";
          if (v.options && data.state.fieldsObj[v.fieldkey] && data.state.fieldsObj[v.fieldkey].values) {
            valDropdown = v.options.filter(row => row.id == data.state.fieldsObj[v.fieldkey].values.id)[0]
          }
          fieldsArray.push(<Grid item xs={12}>
            <FormControl className="w-100 input_bx">
              <SelectValidator
                className="input_bx"
                disabled={v.recordeditdefaultvalue == 3 ? true : false}
                value={valDropdown}
                onChange={(event) => data.handleChange({ fieldid: v.id, values: event.target.value }, v.fieldkey,'allowSubmitChange')}
                name={v.fieldkey}
                id={v.id}
                placeholder={"Add " + v.fieldlabel}
                label={v.fieldlabel}
                ref={ref => data[v.fieldkey] = ref}
                
              >
                {v.options && v.options.map((item, key) =>
                  <MenuItem className="select-menu-item w-100 input_bx" key={item.id} value={item}>{item.name}</MenuItem>
                )}
                {v.options && v.id == "3" &&
                  <MenuItem className="select-menu-item item-with-link" value={'link'}><Link to="/settings/lead-statuses">Customize Lead Statuses</Link></MenuItem>
                }
              </SelectValidator>
            </FormControl>
          </Grid>
          )
        } else {
          var valDropdown = {};
          if (v.options && data.state.fieldsObj[v.fieldkey] && data.state.fieldsObj[v.fieldkey].values) {
            //valDropdown = data.state.fieldsObj[v.fieldkey].values
            valDropdown = v.options.filter(row => row.id == data.state.fieldsObj[v.fieldkey].values.id)[0]
          }
          fieldsArray.push(<Grid item xs={12}>
            <FormControl className="w-100 input_bx">
              {/* <InputLabel>{v.fieldlabel}</InputLabel> */}
              <SelectValidator
                className="mb-16 input_bx"
                label={v.fieldlabel}
                disabled={v.recordeditdefaultvalue == 3 ? true : false}
                value={valDropdown}
                placeholder={"Add " + v.fieldlabel}
                onChange={(event) => data.handleChange({ fieldid: v.id, values: event.target.value }, v.fieldkey,'allowSubmitChange')}
                name={v.fieldlabel}
                id={v.id}
                ref={ref => data[v.fieldkey] = ref}
                
              >
                {v.options && v.options.map((item, key) =>
                  <MenuItem className="select-menu-item w-100 input_bx" key={item.id} value={item}>{item.optionvalue}</MenuItem>
                )}

              </SelectValidator>
            </FormControl>
          </Grid>
          )
        }
      }
      if (v.fieldtype.id == '5') {//multi dropdown
        var multiSelectedVal = [];
        if (data.state.fieldsObj[v.fieldkey] && data.state.fieldsObj[v.fieldkey].values && data.state.fieldsObj[v.fieldkey].values.length > 0) {
            multiSelectedVal = v.options.filter(row => data.state.fieldsObj[v.fieldkey].values.filter(val => val.id == row.id).length);
        }
        
        fieldsArray.push(<Grid item xs={12}>
          <FormControl className="w-100 input_bx">
            <Autocomplete
              multiple
              value={multiSelectedVal}
              disabled={v.recordeditdefaultvalue == 3 ? true : false}
              name={v.fieldkey}
              onChange={(event, value) => data.handleChange({ fieldid: v.id, values: value }, v.fieldkey,'allowSubmitChange')}
              id={v.id}
              options={v.options}
              getOptionLabel={option => option.optionvalue}
              renderInput={params => (
                <TextValidator
                  ref={ref => data[v.fieldkey] = ref}
                  onBlur={(event) => data.focusOutSubmitForm(event,v.fieldkey)}
                  {...params}
                  variant="standard"
                  label={v.fieldlabel}
                  placeholder={"Add " + v.fieldlabel}
                  fullWidth
                  className="mb-16 input_bx"
                />
              )}
            />
          </FormControl>
        </Grid>
        )
      }
      if (v.fieldtype.id == '3') {//checkbox field
        fieldsArray.push(<Grid item xs={12} className="checkbox-margin-18">
          <FormControl className="w-100 input_bx">
            <FormControlLabel
              control={
                <Checkbox
                  name={v.fieldkey}
                  id={v.id}
                  checked={(data.state.fieldsObj[v.fieldkey] && data.state.fieldsObj[v.fieldkey].leadvalue == "1") ? true : false}
                  onChange={(event, value) => data.handleChange({ fieldid: v.id, leadvalue: value ? "1" : "0" }, v.fieldkey,'allowSubmitChange')}
                  value={data.state.fieldsObj[v.fieldkey] ? data.state.fieldsObj[v.fieldkey].leadvalue : ""}
                  color="primary"
                />
              }
              label={v.fieldlabel}
            />
          </FormControl>
        </Grid>
        )
      }
      if (v.fieldtype.id == '8') {//datepicker field
        var dtFormat = "MM/dd/yyyy";
        var selectedDate = data.state.selectedDate;
        if (data.state.fieldsObj[v.fieldkey]) {
          selectedDate = data.state.fieldsObj[v.fieldkey].values
        }

        if(data.state.userSettings != ""){
          dtFormat = data.state.userSettings.dateformat;
          dtFormat = dtFormat.replace("DD", "dd").replace("YYYY", "yyyy");
        }

        fieldsArray.push(<Grid item xs={12} >
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <FormControl className="w-100 input_bx">
            <KeyboardDatePicker
                label={v.fieldlabel}
                format={dtFormat}
                placeholder={dtFormat}
                error={(selectedDate=="Invalid Date")?true:false}
                value={selectedDate}
                onChange={(event,value) => data.handleChange({ fieldid: v.id, values: event=="Invalid Date"?"Invalid Date":event}, v.fieldkey,'allowSubmitChange')}
                KeyboardButtonProps={{
                    'aria-label': 'change date',
                }}
                helperText={(selectedDate=="Invalid Date")?"enter valid date.":""}

            />
          </FormControl>
          </MuiPickersUtilsProvider>
        </Grid>
        )
      }
    }
  })

  return fieldsArray;
}